import type {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue,
  TagDescription,
} from '@reduxjs/toolkit/query';
import type { TAppApiTags } from './app.constants';

export function defaultHeaders(
  headers: Headers,
  token?: string,
  sessionId?: string,
) {
  const defaultHeader: Headers = headers;

  if (token) {
    defaultHeader.set('Authorization', `Bearer ${token}`);
  }

  // Only MULTI_ORG logins have a session; an explicit per-request header wins.
  if (sessionId && !defaultHeader.has('X-Session-Id')) {
    defaultHeader.set('X-Session-Id', sessionId);
  }

  defaultHeader.set('ngrok-skip-browser-warning', 'true');
  return defaultHeader;
}

export async function defaultErrorMsg(
  result: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>,
) {
  if (result.error) {
    // console.log('Unauthorized Log', result);
  }
  // if (
  //   result.error &&
  //   result.error?.status === 401
  //   // (result?.error?.data as any)?.message === "Unauthorized"
  // ) {
  //   try {
  //     localStorage.clear();
  //   } catch (err) {
  //     console.error('Logout failed:', err);
  //   }
  // }
}

export type TTag = TAppApiTags | { type: TAppApiTags; id?: boolean };
export const invalidateOnSuccess = (tags: TTag | TTag[]) => {
  return (
    result?: { success?: boolean },
    error?: FetchBaseQueryError,
    args?: { id?: string; data?: any; body?: any; [key: string]: any },
  ): readonly TagDescription<TAppApiTags>[] => {
    if (error) return [];
    if (result?.success === false) return [];

    const inputTags = Array.isArray(tags) ? tags : [tags];

    const filteredTags = inputTags.filter((tag) => {
      if (typeof tag === 'object' && tag.id === true && !args?.id) return false;
      return true;
    });

    return filteredTags.map((tag) => {
      if (typeof tag === 'object' && tag.id === true && args?.id) {
        return { type: tag.type, id: args.id };
      }
      return tag as TagDescription<TAppApiTags>;
    });
  };
};
